module.exports = {"pathContext":{"name":"UpsertProductConfigInput","kind":"INPUT_OBJECT","type":"OBJECT","fields":[{"defaultValue":null,"description":null,"name":"defaultNotes","type":{"kind":"SCALAR","name":"String","ofType":null}},{"defaultValue":null,"description":null,"name":"dosageConfig","type":{"kind":"INPUT_OBJECT","name":"DosageConfigInput","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/input-object-upsert-product-config-input.json
// module id = 1598
// module chunks = 245665268606781